import React from "react";
import { Container, Table } from "react-bootstrap";

export default function ProfileSummary({ data, title, headers, columns }) {
  if (
    data &&
    data.length > 0 &&
    headers.length === columns.length &&
    headers &&
    columns
  ) {
    return (
      <Container className="py-2 px-1">
        <strong>{title || ""}</strong>
        <Table bordered size="sm">
          <thead>
            <tr>
              {headers.map((header) => (
                <th>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr>
                {columns.map((col) => (
                  <td>{item[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    );
  } else {
    return null;
  }
}
